(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    if (!window.__prettyPortalFacetsMobileToggleInitialized) {
    window.__prettyPortalFacetsMobileToggleInitialized = true;

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let mobileToggleObserver = null;

    const setMobileToggleState = (sentinel, isStuck) => {
      const toggle = sentinel.nextElementSibling;
      if (!toggle?.matches('[data-facets-mobile-toggle]')) return;
      toggle.classList.toggle('is-stuck', isStuck);
    };

    const setupMobileFilterToggles = () => {
      if (mobileToggleObserver) {
        mobileToggleObserver.disconnect();
      }

      mobileToggleObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const isPastTop = entry.boundingClientRect.top < 0;
          setMobileToggleState(entry.target, mobileQuery.matches && !entry.isIntersecting && isPastTop);
        });
      });

      document.querySelectorAll('[data-facets-toggle-sentinel]').forEach((sentinel) => {
        setMobileToggleState(sentinel, false);
        mobileToggleObserver.observe(sentinel);
      });
    };

    const resetMobileFilterToggles = () => {
      document.querySelectorAll('[data-facets-mobile-toggle]').forEach((toggle) => {
        toggle.classList.remove('is-stuck');
      });
      setupMobileFilterToggles();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupMobileFilterToggles);
    } else {
      setupMobileFilterToggles();
    }

    document.addEventListener('shopify:section:load', setupMobileFilterToggles);
    mobileQuery.addEventListener('change', resetMobileFilterToggles);
  }
  } catch(e) { console.error(e); }
})();

})();
